// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"DeleteAccount_FullWidth__3iNbr","TextAlert":"DeleteAccount_TextAlert__2IsLH","PaymentImage":"DeleteAccount_PaymentImage__13SrF","Timer":"DeleteAccount_Timer__1Zuza"};